import { transliterate } from './transliterate';

export const getBrandLink = (brand: string) => {
  return `/brands/${transliterate(brand)}/`;
};
